import { validationErrors } from "../utils";
import ajaxService from "./ajax-service";

class VendorContainerPayment {
  async fetch(page, data, all = false) {
    const param = all ? "all=true" : `page=${page}`;

    const response = await ajaxService.post(
      `/vendors-container-payment?${param}`,
      data
    );
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
}

const VCPaymentService = new VendorContainerPayment();
export default VCPaymentService;
